import { CONSTRUCTION_AUTODESK_URL } from '../../../helpers/const';

export const PRICING_URL = `${CONSTRUCTION_AUTODESK_URL}/pricing`;

export const AUTOSPECS_TRIAL_MARKETING_URL =
  'https://getconstructioncloud.autodesk.com/autospecs';

export const OFFERINGS_CATEGORIES = {
  AUTOSPECS: 'autodesk-autospecs',
};

export const OFFERING_NAMES = {
  AUTOSPECS: 'AutoSpecs',
};
